var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.accountName != null)?_c('span',[_vm._v(_vm._s(_vm.accountName)+" "),(!_vm.hideId)?_c('small',{staticClass:"text-secondary"},[_c('br'),_vm._v(_vm._s(_vm.accountId))]):_vm._e()]):_c('span',[_vm._v(_vm._s(_vm.merchantId))])])
}
var staticRenderFns = []

export { render, staticRenderFns }